module.exports = __webpack_public_path__ + "img/1655811862698strublogo.cd749f12.jpg";